<template>
    <div style="height: 100%">
        <RupturaList v-show="!rotaAninhada" :reloadData="reloadData" />
        <router-view />
    </div>
</template>

<script>
import RupturaList from '@/components/vendas/relatorios/relatorio-analitico/relatorio-ausencia-checkin/RelatorioAusenciaCheckinList.vue';

export default {
    name: 'RelatorioAusenciaCheckinListRoute',

    beforeRouteUpdate(to, from, next) {
        this.rotaAninhada = to.name != 'ausencia-checkin-cliente-list';
        if (from.name != 'ausencia-checkin-cliente-list' && to.name == 'ausencia-checkin-cliente-list') {
            this.reloadData = true;
            setTimeout(() => (this.reloadData = false), 300);
        }
        next();
    },
    components: {
        RupturaList,
    },
    data() {
        return {
            rotaAninhada: false,
            reloadData: false,
        };
    },
    created() {
        this.rotaAninhada =
            this.$route.name.includes('ausencia-checkin-cliente') &&
            this.$route.name != 'ausencia-checkin-cliente-list';
    },
};
</script>
